import { render } from "./SalonMap.vue?vue&type=template&id=f9ee46f6"
import script from "./SalonMap.vue?vue&type=script&lang=js"
export * from "./SalonMap.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__